"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.socialMedia.column.platform': 'Piattaforma',
    'settings.socialMedia.column.status': 'Stato',
    'settings.socialMedia.x.title': 'X (Twitter)',
    'settings.socialMedia.x.description': 'Collega il tuo account X per pubblicare.',
    'settings.socialMedia.x.connect': 'Connetti X',
    'settings.socialMedia.x.disconnect': 'Disconnetti X',
    'settings.socialMedia.x.disconnected': 'X disconnesso',
    'settings.socialMedia.x.connectFailed': 'Connessione a X fallita',
    'settings.socialMedia.x.disconnectFailed': 'Disconnessione da X fallita',
    'settings.socialMedia.ig.title': 'Instagram',
    'settings.socialMedia.ig.description': 'Collega il tuo account Instagram Business per pubblicare.',
    'settings.socialMedia.ig.connect': 'Collega Instagram',
    'settings.socialMedia.ig.disconnect': 'Scollega Instagram',
    'settings.socialMedia.ig.disconnected': 'Instagram scollegato',
    'settings.socialMedia.ig.connectFailed': 'Connessione a Instagram fallita',
    'settings.socialMedia.ig.disconnectFailed': 'Disconnessione da Instagram fallita',
    'settings.socialMedia.fb.title': 'Facebook',
    'settings.socialMedia.fb.description': 'Collega il tuo account Facebook per pubblicare.',
    'settings.socialMedia.fb.connect': 'Connetti Facebook',
    'settings.socialMedia.fb.disconnect': 'Disconnetti Facebook',
    'settings.socialMedia.fb.disconnected': 'Facebook disconnesso',
    'settings.socialMedia.fb.connectFailed': 'Connessione a Facebook fallita',
    'settings.socialMedia.fb.disconnectFailed': 'Disconnessione da Facebook fallita',
    'settings.socialMedia.yt.title': 'YouTube',
    'settings.socialMedia.yt.description': 'Collega il tuo canale YouTube per pubblicare video.',
    'settings.socialMedia.yt.connect': 'Collega YouTube',
    'settings.socialMedia.yt.disconnect': 'Scollega YouTube',
    'settings.socialMedia.yt.disconnected': 'YouTube scollegato',
    'settings.socialMedia.yt.connectFailed': 'Connessione a YouTube fallita',
    'settings.socialMedia.yt.disconnectFailed': 'Disconnessione da YouTube fallita',
    'settings.socialMedia.tt.title': 'TikTok',
    'settings.socialMedia.tt.description': 'Collega il tuo account TikTok per pubblicare video.',
    'settings.socialMedia.tt.connect': 'Collega TikTok',
    'settings.socialMedia.tt.disconnect': 'Scollega TikTok',
    'settings.socialMedia.tt.disconnected': 'TikTok scollegato',
    'settings.socialMedia.tt.connectFailed': 'Connessione a TikTok fallita',
    'settings.socialMedia.tt.disconnectFailed': 'Disconnessione da TikTok fallita',
    'settings.socialMedia.li.title': 'LinkedIn',
    'settings.socialMedia.li.description': 'Collega il tuo account LinkedIn per pubblicare.',
    'settings.socialMedia.li.connect': 'Collega LinkedIn',
    'settings.socialMedia.li.disconnect': 'Scollega LinkedIn',
    'settings.socialMedia.li.disconnected': 'LinkedIn scollegato',
    'settings.socialMedia.li.connectFailed': 'Connessione a LinkedIn fallita',
    'settings.socialMedia.li.disconnectFailed': 'Disconnessione da LinkedIn fallita',
    'settings.socialMedia.pt.title': 'Pinterest',
    'settings.socialMedia.pt.description': 'Collega il tuo account Pinterest per pubblicare Pin.',
    'settings.socialMedia.pt.connect': 'Collega Pinterest',
    'settings.socialMedia.pt.disconnect': 'Scollega Pinterest',
    'settings.socialMedia.pt.disconnected': 'Pinterest scollegato',
    'settings.socialMedia.pt.connectFailed': 'Impossibile collegare Pinterest',
    'settings.socialMedia.pt.disconnectFailed': 'Impossibile scollegare Pinterest',
    'settings.socialMedia.th.title': 'Threads',
    'settings.socialMedia.th.description': 'Collega il tuo account Threads per pubblicare contenuti.',
    'settings.socialMedia.th.connect': 'Collega Threads',
    'settings.socialMedia.th.disconnect': 'Scollega Threads',
    'settings.socialMedia.th.disconnected': 'Threads scollegato',
    'settings.socialMedia.th.connectFailed': 'Impossibile collegare Threads',
    'settings.socialMedia.th.disconnectFailed': 'Impossibile scollegare Threads',
    'settings.socialMedia.dictionary.title': 'Dizionari Social Media',
    'settings.socialMedia.dictionary.type': 'Tipo',
    'settings.socialMedia.dictionary.type.tone': 'Tono',
    'settings.socialMedia.dictionary.type.goal': 'Obiettivo',
    'settings.socialMedia.dictionary.type.audience': 'Pubblico',
    'settings.socialMedia.dictionary.key': 'Chiave',
    'settings.socialMedia.dictionary.label': 'Etichetta',
    'settings.socialMedia.dictionary.icon': 'Icona',
    'settings.socialMedia.dictionary.order': 'Ordine',
    'settings.socialMedia.dictionary.active': 'Attivo',
    'settings.socialMedia.dictionary.add': 'Aggiungi',
    'settings.socialMedia.dictionary.edit': 'Modifica',
    'settings.socialMedia.dictionary.delete': 'Elimina',
    'settings.socialMedia.dictionary.editTitle': 'Modifica elemento dizionario',
    'settings.socialMedia.dictionary.addTitle': 'Aggiungi elemento dizionario',
    'settings.socialMedia.dictionary.save': 'Salva',
    'settings.socialMedia.dictionary.cancel': 'Annulla',
    'settings.socialMedia.dictionary.loadFailed': 'Impossibile caricare i dizionari',
    'settings.socialMedia.dictionary.fillRequired': 'Compila tutti i campi obbligatori',
    'settings.socialMedia.dictionary.saved': 'Elemento dizionario salvato',
    'settings.socialMedia.dictionary.saveFailed': 'Impossibile salvare l\'elemento dizionario',
    'settings.socialMedia.dictionary.deleted': 'Elemento dizionario eliminato',
    'settings.socialMedia.dictionary.deleteFailed': 'Impossibile eliminare l\'elemento dizionario',
    'settings.socialMedia.dictionary.deleteConfirm': 'Eliminare questo elemento dizionario?',
    'settings.socialMedia.dictionary.actions': 'Azioni',
};
